module.exports = __webpack_public_path__ + "assets/lock-black.b13d7246.svg";